//WE.Flow.Html.Contracts.Manifests.ConfigItemManifest

export class ConfigItemManifest {
    name: string = "";
    groupName: string = "";
}
